







































































































// @ts-nocheck

import Vue from "vue"
import {mapMutations, mapActions, mapState} from "vuex"
import {pr} from "@/helpers/functions"
import apidb from "@/providers/apidb"
import url from "@/helpers/url"
import get_filters from "@/helpers/filter"
import {get_obj_list, config, grid} from "@/modules/ipblacklist/queries"


import notifsnack from "@/components/common/notifications/notification_snackbar.vue"
import barover from "@/components/common/bars/progress_barover.vue"
import submenu from "@/components/common/menus/submenu_rudc.vue"
import detail from "@/modules/ipblacklist/detail.vue"
//import forminsert from "@/modules/ipblacklist/form_insert.vue"
//import formupdate from "@/modules/ipblacklist/form_update.vue"
//import formdelete from "@/modules/ipblacklist/form_delete.vue"
//import formclone from "@/modules/ipblacklist/form_clone.vue"

export default Vue.extend({
  name: "ipblacklist-index",
  
  components: {
    notifsnack,
    submenu,
    //forminsert,
    detail,
    //formupdate,
    //formdelete,
    //formclone,
    barover,
  },

  data: () => ({

    issubmenu: false,
    evtsubmenu: {x:0,y:0},

    isfetching: false,
    showform: false,
    crudopt: "",

    search: "",
    
    objrow: {},

    headers: grid.headers,
    arrows: [],

    snack:{
      isvisible:false,
      innertext: "",
    },

    page:{
      ipage: 1,     //pagina actual
      ippage: 50,  //regs por pag
      ipages: 0,    //num de paginas
      foundrows:0,  //total de registros
    },

    dbsearch:"",

  }),//data

  watch:{
    dbsearch(val) {
      if (!val) {
        return;
      }

      this.on_dbsearch(val);
    }
  },

  //no puede ser asincrono pq el ciclo de vida no aplica await
  beforeMount(){
    console.log("ipblacklist.index.beforeMount")
  },


  //lo marco como async pq tengo que resolver peticiones
  mounted: async function(){

    console.log("ipblacklist.index.mounted.islogged antes de llamar a async_islogged",this.islogged)
    //async_islogged comprueba el token en local si existe comprueba si es válido
    //si pasa estos filtros this.islogged tendría el valor true
    const response = await this.async_islogged()
    console.log("ipblacklist.index.mounted.islogged",this.islogged)

    if(!this.islogged){
      this.$router.push({name:"login"})
      return
    }

    //error network
    if(response.error){
      this.$emit("evterror",response.error)
      return 
    }

    console.log("ipblacklist.index.mounted islogged:",this.islogged)
    const objpage = this.get_page()

    this.page.ipage = objpage.ipage
    const objparam = {
      page: {...objpage},
      filters: {}
    }

    //pr(objparam,"objparam in async")
    await this.async_loaddata(objparam)
  },

  computed:{
    ...mapState(["islogged"]),
  },

  methods:{
    //setters
    ...mapActions(["async_islogged"]),

    get_page(){
      const ipage = parseInt(url.get_param("page",this.$route)) || 1
      const ippage = this.page.ippage
      const ifrom = (ipage-1) * ippage

      return {
        ipage: ipage,
        ippage: ippage,
        ifrom: ifrom,
      }
    },
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
    async_loaddata: async function(objparam: any={page:{},filters:{}}){
      this.isfetching = true
      const objquery = get_obj_list(objparam)
      const response = await apidb.async_get_list(objquery)

      this.arrows = response.result
      this.page.ipage = objparam.page.ipage
      this.page.foundrows = response.foundrows
      this.page.ipages = Math.ceil(this.page.foundrows/objparam.page.ippage)

      console.table("ipblacklist.index.async_loaddata.page.foundrows:",(this.page.foundrows as any))
      this.isfetching = false

      //si hay un formulario en pantalla no se le aplica el foco a esto
      if(!this.showform)
        (this.$refs.dbsearch as any).focus()

    }, //async_loaddata
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
    on_dbsearch(text) {
      // cancel pending call
      clearTimeout(this.debounceid);

      this.issearching = true;
      // delay new call 500ms
      ;this.debounceid = setTimeout(() => {
        text = text.trim()
        if(this.$route.path !== `/ip-blacklist/1`){
          this.$router.push({ name: 'ipblacklist', params: { page: 1 } })
        }
      
        const objpage = this.get_page()

        this.page.ipage = objpage.ipage
        const objparam = {
          page: {...objpage},
          filters: {}
        }

        if(text!==""){
          objparam.filters = get_filters(text, config)
          //pr(objparam,"objparam")
          this.async_loaddata(objparam)
        }
        else
          this.async_loaddata(objparam)

        ;this.issearching = false
      }, 1000);

    },   

    on_paginate(ipage){
      if(this.$route.path !== `/ip-blacklist/${ipage}`)
        this.$router.push({ name: 'ipblacklist', params: { page: ipage } })

      const objpage = this.get_page()
      //pr(objpage,`ipage: ${ipage}`)

      this.page.ipage = objpage.ipage
      const objparam = {
        page: {...objpage},
        filters: {}
      }      
      if(this.dbsearch)
        objparam.filters = get_filters(this.dbsearch, config)

      this.async_loaddata(objparam)
    },

    show_form(){
      this.showform = true
    },

    form_result(val){
      const objpage = this.get_page()
      //pr(objpage,`ipage: ${ipage}`)

      this.page.ipage = objpage.ipage
      const objparam = {
        page: {...objpage},
        filters: {}
      }      
      if(this.dbsearch)
        objparam.filters = get_filters(this.dbsearch, config)

      this.async_loaddata(objparam)
    },

    insert(){
      this.crudopt = "insert"
      this.show_form()
    },

    update(objrow){
      this.crudopt = "update"
      this.objrow = objrow
      this.show_form()
    },

    clone(objrow){
      this.crudopt = "clone"
      this.objrow = objrow
      this.show_form()
    },    

    remove(objrow){
      this.crudopt = "delete"
      this.objrow = objrow
      this.show_form()
    },

    submenu(objrow){
      const e = window.event
      this.objrow = objrow
      this.issubmenu = true
      this.evtsubmenu = e as any
    },

    submenu_selected(option){
      this.crudopt = option
      this.show_form()
    },
    
  }//methods  

});
